import { Button, Divider, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../configs/api";
import { AddRelation } from "./AddRelation";
import AddIdentification from "./AddIdentification";
import useAuth from "../../../components/hooks/useAuth";
import PhoneNumberInput from "../../../components/common/PhoneNumberInput";
import EmailAlreadyExistChecking from "../../../components/EmailAlreadyExistChecking";
import { getCustomerEmailChecking } from "../../../services/EmailChecking";
import { getCustomersExtraInformationsByCustomerId } from "../../../services/customerExtraInformation";
import { delete_Relation, getRelationByCustomer } from "../../../services/relation";
import { AddOutlined, Delete, Edit } from "@mui/icons-material";
import EditRelation from "./EditRelation";
import useConfirm from "../../../components/hooks/useConfirm";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import axois from "../../../configs/axois";
import { useTheme } from "../../../components/hooks/useTheme";
import useDelete from "../../../components/hooks/useDelete";
import { put_Customer } from "../../../services/customer";
import colorConfigs from "../../../configs/colorConfigs";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";

type ExtraInformation = {
    id: number;
    idNumber: string;
    issueDate: string;
    exprationDate: string;
    filePath: string;
    idTypeId: string;
    customerId: number;
    type: string;
    imageSize: number,
    uploadedAt: string,
    uploadedBy: string
};

const monthNameOptions = [
    { value: "1", label: "1. January" },
    { value: "2", label: "2. February" },
    { value: "3", label: "3. March" },
    { value: "4", label: "4. April" },
    { value: "5", label: "5. May" },
    { value: "6", label: "6. June" },
    { value: "7", label: "7. July" },
    { value: "8", label: "8. August" },
    { value: "9", label: "9. September" },
    { value: "10", label: "10. October" },
    { value: "11", label: "11. November" },
    { value: "12", label: "12. December" },
];

const daysOptions: any = [];
for (let i = 1; i <= 31; i++) {
    daysOptions.push({ value: i, label: i });
}

const yearOptions: any = [];
for (let i = 1940; i <= new Date().getFullYear(); i++) {
    yearOptions.push({ value: i, label: i });
}

type Props = {
    idNumber: string;
    customerData: any | null;
    setCustomerData: (value: any) => void;
};

const Contact = ({ idNumber, customerData, setCustomerData }: Props) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { handleTenantError }: any = useTenant();
    const { auth }: any = useAuth();
    const { dateFormat }: any = useGeneral();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [disabeld, setDisabled] = useState<boolean>(true);
    const [currFullName, setCurrFullName] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [Street, setStreet] = useState<string>("");
    const [street2, setStreet2] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [zip, setZip] = useState<string>("");
    const [day, setDay] = useState<string>("");
    const [month, setMonth] = useState<string>("");
    const [year, setYear] = useState<string>("");
    const [isRedFlag, setIsRedFlag] = useState<boolean>(false);
    const [redFlagReason, setRedFlagReason] = useState<string>("");
    const [isAddRelationShown, setIsAddRelationShown] = useState<boolean>(false);
    const [isEditRelationShown, setIsEditRelationShown] = useState<boolean>(false);
    const [extraRow, setExtraRow] = useState<ExtraInformation[]>([]);
    const [allExtraValue, setAllExtraValue] = useState<boolean>(false);
    const [indexNumber, setIndexNumber] = useState<number>(0);
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [allRelation, setAllRelation] = useState<any[]>([]);
    const [refreshRelation, setRefreshRelation] = useState<boolean>(true);
    const [relationData, setRelationData] = useState<any>({});
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [pleaseWait, setPleaseWait] = useState<boolean>(false);

    useEffect(() => {
        setPleaseWait(true);
        axois
            .get(`${baseURL}Customer/${idNumber}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setCustomerData(response.data);
                setExtraRow([]);
                setRefreshRelation(true);
                setPleaseWait(false);
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
                setPleaseWait(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);


    useEffect(() => {
        if (customerData) {
            setCurrFullName(customerData.firstName + " " + customerData.lastName);
            setFirstName(customerData.firstName);
            setLastName(customerData.lastName);
            setEmailAddress(customerData.emailAddress);
            setPhoneNumber(customerData.phoneNumber);
            setStreet(customerData.street);
            setStreet2(customerData.street2);
            setCity(customerData.city);
            setState(customerData.state);
            setCountry(customerData.country);
            setZip(customerData.zip);
            setYear(new Date(customerData.birthday).getFullYear().toString());
            setDay(new Date(customerData.birthday).getDate().toString());
            setMonth((new Date(customerData.birthday).getMonth() + 1).toString());
            setIsRedFlag(customerData?.isRedFlag);
            setRedFlagReason(customerData?.redFlagReason);

            getCustomersExtraInformationsByCustomerId(parseInt(idNumber), tenantId)
                .then((data) => {
                    setExtraRow(
                        data?.filter((item: ExtraInformation) => parseInt(item.idTypeId) !== 0)
                            ?.map((item: ExtraInformation, index: number) => {
                                return {
                                    id: index + 1,
                                    idNumber: item.idNumber,
                                    issueDate: moment(new Date(item.issueDate)).format(dateFormat),
                                    exprationDate: moment(new Date(item.exprationDate)).format(dateFormat),
                                    filePath: item.filePath,
                                    idTypeId: item.idTypeId,
                                    customerId: item.customerId,
                                    type: `PUT ${item.id}`,
                                    imageSize: item.imageSize,
                                    uploadedAt: item.uploadedAt,
                                    uploadedBy: item.uploadedBy

                                };
                            })
                    );

                    if (data?.filter((item: ExtraInformation) => parseInt(item.idTypeId) !== 0)?.length > 0) {
                        setAllExtraValue(true);
                    }
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData]);

    useEffect(() => {
        if (idNumber && refreshRelation) {
            getRelationByCustomer(idNumber, tenantId)
                .then((data) => {
                    setAllRelation(data);
                    setRefreshRelation(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setRefreshRelation(false);
                    handleTenantError(error);
                })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber, refreshRelation])

    const handleAddExtraRow = () => {
        setIndexNumber(indexNumber + 1);

        const data: ExtraInformation = {
            id: indexNumber,
            idNumber: "",
            issueDate: "",
            exprationDate: "",
            filePath: "",
            idTypeId: "",
            customerId: customerData.id,
            type: "POST",
            imageSize: 0,
            uploadedAt: moment(new Date()).format(dateFormat + " hh:mm:ss a"),
            uploadedBy: auth.givenname,
        };

        setExtraRow((extraRow: ExtraInformation[]) => [...extraRow, data]);
    };

    const handleDeleteExtraRow = async (index: number) => {
        if (extraRow.find((row: ExtraInformation) => row.id === index)?.type.split(" ")[0] === "PUT") {
            await axios
                .delete(`${baseURL}customerExtraInformation?id=${extraRow.find((row: ExtraInformation) => row.id === index)?.type.split(" ")[1]}&userId=${auth?.id}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                .then(() => {
                    const newRow: ExtraInformation[] = extraRow.filter(
                        (row: ExtraInformation) => row.id !== index
                    );
                    setExtraRow(newRow);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } else {
            const newRow: ExtraInformation[] = extraRow.filter(
                (row: ExtraInformation) => row.id !== index
            );
            setExtraRow(newRow);
        }
    };

    const changeOnExtraValue = (row: ExtraInformation) => {
        const updatedExtraRow = extraRow.map((rowValue: ExtraInformation) => {
            return rowValue.id === row.id ? row : rowValue;
        })
        setExtraRow(updatedExtraRow);
    };

    useEffect(() => {
        if (allExtraValue) {
            const lastIndexValue: any = extraRow.find(
                (item: ExtraInformation) => extraRow[extraRow.length - 1] === item
            );

            if (lastIndexValue) {
                setIndexNumber(lastIndexValue?.id + 1);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allExtraValue]);


    const navigate = useNavigate();
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setPleaseWait(true);

        const paddedMonth = month.toString().padStart(2, "0");
        const paddedDay = day.toString().padStart(2, "0");
        const birthday = new Date(`${year}-${paddedMonth}-${paddedDay}`);

        await put_Customer({
            id: idNumber,
            firstName,
            lastName,
            emailAddress,
            phoneNumber,
            Street,
            street2,
            city,
            state,
            country,
            zip,
            birthday,
            isRedFlag,
            redFlagReason
        }, auth?.id, tenantId)
            .then(() => {
                savedExtraInfo();
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWait(false);
                handleTenantError(error);
            });
    };

    const savedExtraInfo = () => {
        if (extraRow?.length > 0) {
            let count = 0;
            extraRow?.forEach(async (item: ExtraInformation) => {
                if (item.type.split(" ")[0] === "POST") {
                    await axios
                        .post(
                            `${baseURL}customerExtraInformation?userId=${auth?.id}`,
                            JSON.stringify({
                                idNumber: item.idNumber,
                                issueDate: new Date(item.issueDate),
                                exprationDate: new Date(item.exprationDate),
                                filePath: item.filePath,
                                idTypeId: item.idTypeId,
                                customerId: item.customerId,
                                imageSize: item.imageSize,
                                uploadedAt: new Date(item.uploadedAt),
                                uploadedBy: item.uploadedBy
                            }),
                            {
                                headers: {
                                    'X-Tenant-ID': tenantId,
                                    "Content-Type": "application/json"
                                },
                                withCredentials: true,
                            }
                        )
                        .then(() => {
                            count++;
                            if (extraRow?.length === count) {
                                setPleaseWait(false);
                                navigate(-1);
                            }
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            setPleaseWait(false);
                            handleTenantError(error);
                        });
                } else if (item.type.split(" ")[0] === "PUT") {
                    await axios
                        .put(
                            `${baseURL}customerExtraInformation?userId=${auth?.id}`,
                            JSON.stringify({
                                id: item.type.split(" ")[1],
                                idNumber: item.idNumber,
                                issueDate: new Date(item.issueDate),
                                exprationDate: new Date(item.exprationDate),
                                filePath: item.filePath,
                                idTypeId: item.idTypeId,
                                customerId: item.customerId,
                                imageSize: item.imageSize,
                                uploadedAt: new Date(item.uploadedAt),
                                uploadedBy: item.uploadedBy
                            }),
                            {
                                headers: {
                                    'X-Tenant-ID': tenantId,
                                    "Content-Type": "application/json"
                                },
                                withCredentials: true,
                            }
                        )
                        .then(() => {
                            count++;
                            if (extraRow?.length === count) {
                                setPleaseWait(false);
                                navigate(-1);
                            }
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            setPleaseWait(false);
                            handleTenantError(error);
                        });
                }
            });
        } else {
            setPleaseWait(false);
            navigate(-1);
        }
    };

    const handleDeleteRelation = (relationId: number, customer: number) => {
        setConfirmPopup(true);
        setConfirmData({
            tilte: `Delete`,
            summary: 'Are you sure you want to delete this relation',
            isConfirm: (callback: any) => {
                setPleaseWait(true);
                delete_Relation(relationId, auth?.id, tenantId)
                    .then(() => {
                        getRelationByCustomer(customer?.toString(), tenantId)
                            .then((data) => {
                                const secondRelationId = data?.find((item: any) => item?.customerId === customerData?.id)?.id;
                                delete_Relation(secondRelationId, auth?.id, tenantId)
                                    .then(() => {
                                        setPleaseWait(false);
                                        setRefreshRelation(true);
                                        handleTenantError(null);
                                    })
                                    .catch((error) => {
                                        setPleaseWait(false);
                                        handleTenantError(error);
                                    })
                                handleTenantError(null);
                            })
                            .catch((error) => {
                                setPleaseWait(false);
                                handleTenantError(error);
                            })
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWait(false);
                        handleTenantError(error);
                    })

                callback();
            }
        });
    }

    const deleteTheCustomer = async () => {
        setDeleteData({
            id: idNumber,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Customer?`,
            isDelete: (callback: any) => {
                setPleaseWait(true);

                axios
                    .delete(`${baseURL}customer?id=${idNumber}&userId=${auth?.id}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                    .then(() => {
                        setPleaseWait(false);
                        navigate(-1);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWait(false);
                        handleTenantError(error);
                    });

                callback();
            }
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                <div className="w-full mt-2">
                    <div className={`w-full pb-4`}>
                        <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                            <div className="flex items-center gap-1.5">
                                <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Customer - {currFullName}</h2>
                            </div>

                            <div className="flex items-center gap-1.5">

                                <button className={`px-[12px] py-[10px] ${colorConfigs.btn.main.tailwind} shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                    onClick={() => {
                                        navigate(`/carrental/reservations/addreservation?customerId=${idNumber}`);
                                    }}
                                >
                                    <span className="text-xs font-medium">New Reservation</span>
                                </button>

                                {
                                    disabeld && (
                                        <button
                                            className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                            onClick={() => setDisabled(false)}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                        <div className="flex">
                            <div className="mt-2 p-2 w-[60%]">
                                <form
                                    onSubmit={(e) => handleSubmit(e)}
                                >
                                    <div className="w-full px-2">
                                        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                            Customer Information
                                        </span>

                                        <Divider className={`w-full ${themeStyles.divider.bg}`} />
                                        <div className="w-full px-2">
                                            <div className="grid grid-cols-2 gap-6 mb-2">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>First Name</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={firstName}
                                                        disabled={disabeld}
                                                        onChange={(e) => setFirstName(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Name</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={lastName}
                                                        disabled={disabeld}
                                                        onChange={(e) => setLastName(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-6 mb-2">
                                                <div>
                                                    <EmailAlreadyExistChecking
                                                        emailAddress={emailAddress}
                                                        setEmailAddress={setEmailAddress}
                                                        getEmailChecking={getCustomerEmailChecking}
                                                        disabeld={disabeld}
                                                        className={{
                                                            label: {
                                                                fontSize: "12px",
                                                                fontWeight: 500,
                                                                color: themeStyles.form.labelTextColor
                                                            },
                                                            input: {
                                                                width: "100%",
                                                                fontSize: "14px",
                                                                borderRadius: "6px",
                                                                outline: "none",
                                                                color: themeStyles.form.inputTextColor
                                                            },
                                                            successMessage: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginTop: '0.25rem',
                                                                fontSize: '0.75rem',
                                                                color: '#00b300',
                                                            },
                                                            errorMessage: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginTop: '0.25rem',
                                                                fontSize: '0.75rem',
                                                                color: '#ff3333',
                                                            },
                                                        }}
                                                        touched={emailTouched}
                                                        setTouched={setEmailTouched}
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Phone Number</label>
                                                    <PhoneNumberInput
                                                        name={"phoneNumber"}
                                                        value={phoneNumber}
                                                        setValue={setPhoneNumber}
                                                        fontSize={"14px"}
                                                        paddingBlock={"5px"}
                                                        required={true}
                                                        disabeld={disabeld}
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-6 mb-2">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Street</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={Street}
                                                        disabled={disabeld}
                                                        onChange={(e) => setStreet(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Street 2</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={street2}
                                                        disabled={disabeld}
                                                        onChange={(e) => setStreet2(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-6 mb-2">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>City</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={city}
                                                        disabled={disabeld}
                                                        onChange={(e) => setCity(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>State</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={state}
                                                        disabled={disabeld}
                                                        onChange={(e) => setState(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-6 mb-2">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Zip</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={zip}
                                                        disabled={disabeld}
                                                        inputMode="numeric"
                                                        onChange={(e) => setZip(e.target.value.replace(/\D/g, ""))}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Country</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={country}
                                                        disabled={disabeld}
                                                        onChange={(e) => setCountry(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="w-full mt-[16px] flex items-center gap-1.5">
                                            <div className="w-[30%]">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Birthday</label>
                                                <Select
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: "transparent",
                                                            color: themeStyles.form.inputTextColor,
                                                            borderRadius: '6px',
                                                            padding: '1px',
                                                            borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: "14px",
                                                            backgroundColor: themeStyles.main.mainBg,
                                                            color: themeStyles.form.inputTextColor,
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected
                                                                ? "#167AC3"
                                                                : state.isFocused
                                                                    ? themeStyles.topBar.menuItemsHoverColor
                                                                    : "transparent",
                                                            color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                            fontWeight: 600
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            color: themeStyles.form.inputTextColor,

                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: themeStyles.form.inputTextColor,
                                                        }),
                                                    }}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isDisabled={disabeld}
                                                    isLoading={false}
                                                    isClearable={false}
                                                    isRtl={false}
                                                    isSearchable={false}
                                                    name="birthday"
                                                    value={monthNameOptions.find(
                                                        (item) => item.value === month
                                                    )}
                                                    onChange={(month: any) =>
                                                        setMonth(month ? month.value : "")
                                                    }
                                                    options={monthNameOptions}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-6">
                                                <Select
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: "transparent",
                                                            color: themeStyles.form.inputTextColor,
                                                            borderRadius: '6px',
                                                            padding: '1px',
                                                            borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: "14px",
                                                            backgroundColor: themeStyles.main.mainBg,
                                                            color: themeStyles.form.inputTextColor,
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected
                                                                ? "#167AC3"
                                                                : state.isFocused
                                                                    ? themeStyles.topBar.menuItemsHoverColor
                                                                    : "transparent",
                                                            color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                            fontWeight: 600
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            color: themeStyles.form.inputTextColor,

                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: themeStyles.form.inputTextColor,
                                                        }),
                                                    }}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isDisabled={disabeld}
                                                    isLoading={false}
                                                    isClearable={true}
                                                    isRtl={false}
                                                    isSearchable={true}
                                                    name="birthday"
                                                    value={daysOptions.find(
                                                        (item: any) => item.value === parseInt(day)
                                                    )}
                                                    onChange={(day: any) =>
                                                        setDay(day ? day.value : "")
                                                    }
                                                    options={daysOptions}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-6">
                                                <Select
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: "transparent",
                                                            color: themeStyles.form.inputTextColor,
                                                            borderRadius: '6px',
                                                            padding: '1px',
                                                            borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: "14px",
                                                            backgroundColor: themeStyles.main.mainBg,
                                                            color: themeStyles.form.inputTextColor,
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected
                                                                ? "#167AC3"
                                                                : state.isFocused
                                                                    ? themeStyles.topBar.menuItemsHoverColor
                                                                    : "transparent",
                                                            color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                            fontWeight: 600
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            color: themeStyles.form.inputTextColor,

                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: themeStyles.form.inputTextColor,
                                                        }),
                                                    }}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isDisabled={disabeld}
                                                    isLoading={false}
                                                    isClearable={false}
                                                    isRtl={false}
                                                    isSearchable={false}
                                                    name="birthday"
                                                    value={yearOptions.find(
                                                        (item: any) => item.value === parseInt(year)
                                                    )}
                                                    onChange={(year: any) =>
                                                        setYear(year ? year.value : "")
                                                    }
                                                    options={yearOptions}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="w-1/2 mt-4">
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Is Red Flag{" "}
                                                <div className="group relative inline-block">
                                                    <HelpOutlineOutlinedIcon sx={{ fontSize: "16px", cursor: "pointer" }} />

                                                    <span className={"absolute z-10 w-[150px] text-[10px] bg-white text-gray-600 text-center py-[5px] rounded border border-gray-400 bottom-full left-1/2 -ml-[75px] invisible group-hover:visible"}>
                                                        <span
                                                            className="absolute top-full left-[51%] -ml-[8px] border-8 border-transparent border-t-white z-10"
                                                        />
                                                        <span
                                                            className="absolute top-full left-1/2 -ml-[8px] border-10 border-transparent border-t-gray-400"
                                                        />
                                                        If set to Yes, this customer will not be able to book a reservation. If No, booking is allowed as usual.
                                                    </span>
                                                </div>
                                            </label>

                                            <RadioGroup
                                                row
                                                value={isRedFlag ? "Yes" : "No"}
                                                onChange={(e) => setIsRedFlag(e.target.value === "Yes" ? true : false)}
                                            >
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "#167AC3",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Yes"
                                                    sx={{
                                                        color: themeStyles.form.labelTextColor
                                                    }}
                                                    disabled={disabeld}
                                                />

                                                <FormControlLabel
                                                    value="No"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "#167AC3",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="No"
                                                    sx={{
                                                        color: themeStyles.form.labelTextColor
                                                    }}
                                                    disabled={disabeld}
                                                />
                                            </RadioGroup>
                                        </div>

                                        {isRedFlag && (
                                            <div className="w-1/2 mt-4">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Red Flag Reason</label>
                                                <textarea
                                                    rows={4}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={redFlagReason}
                                                    onChange={(e) => setRedFlagReason(e.target.value)}
                                                    disabled={disabeld}
                                                ></textarea>
                                            </div>
                                        )}

                                        <span className={`text-[14px] font-semibold inline-block my-4 ${themeStyles.main.textHeadingColor}`}>
                                            Extra Information
                                        </span>

                                        <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                        <div className="w-full mt-2">
                                            <table className="min-w-full">
                                                <tbody className="text-left">
                                                    <tr className={`border-b ${themeStyles.main.borderColor}`}>
                                                        <th className={`w-[15%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Type</th>
                                                        <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>ID Number</th>
                                                        <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Issued On</th>
                                                        <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Exp. Date</th>
                                                        <th className={`w-[25%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>File</th>
                                                    </tr>

                                                    {
                                                        extraRow?.map((row: ExtraInformation, index: number) => {
                                                            return (
                                                                <AddIdentification
                                                                    key={index}
                                                                    itemIndex={row.id}
                                                                    disabeld={disabeld}
                                                                    handleDeleteExtraRow={(index) => handleDeleteExtraRow(index)}
                                                                    birthDay={new Date(`${year}-${month}-${day}`).toDateString()}
                                                                    row={row}
                                                                    changeOnExtraValue={(
                                                                        row
                                                                    ) =>
                                                                        changeOnExtraValue(
                                                                            row
                                                                        )
                                                                    }
                                                                />
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>

                                            {
                                                !disabeld && (
                                                    <div
                                                        className="group h-10 border-dashed !border-t-0 border border-[#D5D4D8] pt-1 flex justify-center items-center cursor-pointer"
                                                        onClick={() => {
                                                            handleAddExtraRow();
                                                        }}
                                                    >
                                                        <p className="text-xs text-center text-[#167AC3] cursor-pointer font-medium group-hover:font-bold group-hover:scale-125">
                                                            <AddOutlined
                                                                sx={{
                                                                    fontSize: "16px",
                                                                    textAlign: "center",
                                                                }}
                                                            />
                                                            Add another Identification
                                                        </p>
                                                    </div>
                                                )
                                            }

                                            <div className="flex gap-4 mt-6">
                                                {
                                                    !disabeld && (
                                                        <Button variant="contained"
                                                            sx={{
                                                                backgroundColor: colorConfigs.btn.main.bg
                                                            }}
                                                            type="submit"
                                                        >
                                                            Save
                                                        </Button>
                                                    )
                                                }

                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={() => navigate(-1)}
                                                >
                                                    Cancel
                                                </Button>

                                                {
                                                    auth?.roles.toLowerCase() === "admin" && (
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: colorConfigs.btn.delete.bg,
                                                            }}
                                                            onClick={() => deleteTheCustomer()}
                                                        >
                                                            Delete
                                                        </Button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="mt-2 p-2 w-[40%]">
                                <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                    Relations
                                </span>

                                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                <div className="w-full mt-2">
                                    <table className="min-w-full">
                                        <tbody className="text-left">
                                            <tr className={`border-b ${themeStyles.main.borderColor}`}>
                                                <th className={`w-[35%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Contact Item</th>
                                                <th className={`w-[35%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Relation</th>
                                                <th className={`w-[30%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Action</th>
                                            </tr>

                                            {
                                                allRelation?.map((item: any, index: number) => {
                                                    return (
                                                        <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                                                            <td className="py-2 w-[35%]">
                                                                <span
                                                                    className={`text-xs font-medium text-blue-500 underline cursor-pointer ${themeStyles.main.textHeadingColor}`}
                                                                    onClick={() => {
                                                                        navigate(`/contacts/customers/editcustomer?id=${item?.customerId}`)
                                                                    }}
                                                                >
                                                                    {item.customerName}
                                                                </span>
                                                            </td>

                                                            <td className="py-2 w-[35%]">
                                                                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item.relation}</span>
                                                            </td>

                                                            <td className="py-2 w-[30%]">
                                                                {!disabeld && (
                                                                    <div className="flex gap-1.5">
                                                                        <Edit sx={{
                                                                            fontSize: "16px",
                                                                            textAlign: "center",
                                                                            paddingTop: "3px",
                                                                            marginRight: "8px",
                                                                            color: "#167AC3",
                                                                            "&:hover": {
                                                                                cursor: "pointer",
                                                                            }
                                                                        }}
                                                                            onClick={() => {
                                                                                setRelationData(item);
                                                                                setIsEditRelationShown(true)
                                                                            }}
                                                                        />
                                                                        <Delete sx={{
                                                                            fontSize: "16px",
                                                                            textAlign: "center",
                                                                            paddingTop: "3px",
                                                                            color: "#D92D20",
                                                                            "&:hover": {
                                                                                cursor: "pointer",
                                                                            }
                                                                        }}
                                                                            onClick={() => {
                                                                                handleDeleteRelation(item.id, item.customerId);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>

                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>

                                    {
                                        !disabeld && (
                                            <div
                                                className="group h-10 border-dashed !border-t-0 border border-[#D5D4D8] pt-1 flex justify-center items-center cursor-pointer"
                                                onClick={() => {
                                                    setIsAddRelationShown(true);
                                                }}
                                            >
                                                <p className="text-xs text-center text-[#167AC3] cursor-pointer font-medium group-hover:font-bold group-hover:scale-125">
                                                    <AddOutlined
                                                        sx={{
                                                            fontSize: "16px",
                                                            textAlign: "center",
                                                        }}
                                                    />
                                                    Add Contact Item
                                                </p>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>


                    </div>
                </div >
            </div >

            {
                isAddRelationShown && (
                    <AddRelation
                        handleAllRelationShowClick={() => setIsAddRelationShown(false)}
                        showPopup={isAddRelationShown}
                        customerData={customerData}
                        setRefreshRelation={setRefreshRelation}
                    />
                )
            }

            {
                isEditRelationShown && (
                    <EditRelation
                        handleAllRelationShowClick={() => setIsEditRelationShown(false)}
                        showPopup={isEditRelationShown}
                        customerData={customerData}
                        setRefreshRelation={setRefreshRelation}
                        relationData={relationData}
                    />
                )
            }

            <PleaseWaitPopup pleaseWaitPopup={pleaseWait} />
        </>
    );
};

export default Contact;